import { render } from "./SeatList.vue?vue&type=template&id=6e06656f&scoped=true"
import script from "./SeatList.vue?vue&type=script&lang=js"
export * from "./SeatList.vue?vue&type=script&lang=js"

import "./SeatList.vue?vue&type=style&index=0&id=6e06656f&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e06656f"]])

export default __exports__